import {   faPlus, faUserEdit , faPenToSquare, faList, faPaintbrush, faPaperPlane} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import {useAuthState} from 'react-firebase-hooks/auth';
import auth from '../../firebase.init';
import useAdmin from '../../hooks/useAdmin';
import Loading from '../../Shared/Loading';

const Deshboard = () => {

    const [user, loading] = useAuthState(auth);
    const [admin] = useAdmin(user);

    if(loading){
        return <Loading/>
    }


    return (
        <div className="drawer drawer-mobile">
        <input id="deshboard_sidebar" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content ">
            <Outlet />
        </div>
        <div className="drawer-side">
            <label htmlFor="deshboard_sidebar" className="drawer-overlay"></label>
            <ul className="menu p-4 overflow-y-auto w-72 bg-white text-base-content">
                {admin && <li><NavLink className="mb-2 font-medium" to='/secretdeshboard'><FontAwesomeIcon icon={faUserEdit}></FontAwesomeIcon> My Profile</NavLink></li>}
                {admin && <li><NavLink className="mb-2 font-medium"  to='/secretdeshboard/secretaboutme'> <FontAwesomeIcon icon={ faPenToSquare } /> About Me</NavLink></li>}
                {admin && <li><NavLink className="mb-2 font-medium"  to='/secretdeshboard/addproject'> <FontAwesomeIcon icon={ faPlus } /> Add Project</NavLink></li>}
                {admin && <li><NavLink className="mb-2 font-medium"  to='/secretdeshboard/addservices'> <FontAwesomeIcon icon={ faPaperPlane } /> Add Service</NavLink></li>}
                {admin && <li><NavLink className="mb-2 font-medium"  to='/secretdeshboard/secretmanageservice'> <FontAwesomeIcon icon={ faList } /> Manage Services</NavLink></li>}
                {admin && <li><NavLink className="mb-2 font-medium"  to='/secretdeshboard/secretmanageproject'> <FontAwesomeIcon icon={ faList } /> Manage Projects</NavLink></li>}
            </ul>
        </div>
    </div>
    );
};

export default Deshboard;